export const BASE_LAYER_IDS = ['scheme', 'satellite', 'hybrid', 'relief']

export const BASE_LAYERS = [
  {
    id: 'scheme',
    label: 'Схема',
    style: 'https://tiles.openfreemap.org/styles/liberty',
  },
  {
    id: 'satellite',
    label: 'Спутник',
    kind: 'satellite',
  },
  {
    id: 'hybrid',
    label: 'Гибрид',
    style: 'https://tiles.openfreemap.org/styles/liberty',
    kind: 'hybrid',
  },
  {
    id: 'relief',
    label: 'Рельеф',
    kind: 'relief',
  },
]

export const TERRAIN_SOURCE = 'terrain-dem'
export const HILLSHADE_LAYER = 'hillshade-layer'
export const SATELLITE_SOURCE = 'satellite'
export const SATELLITE_LAYER = 'satellite-layer'

export const DEM_TILEJSON = 'https://tiles.mapterhorn.com/tilejson.json'

export const SATELLITE_TILES = [
  'https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg',
]

export const OPENTOPO_TILES = ['https://tile.opentopomap.org/{z}/{x}/{y}.png']

const SATELLITE_ATTRIBUTION = '© EOX IT Services GmbH — Sentinel-2 cloudless'

function satelliteSourceSpec() {
  return {
    type: 'raster',
    tiles: SATELLITE_TILES,
    tileSize: 256,
    attribution: SATELLITE_ATTRIBUTION,
    maxzoom: 15,
  }
}

function satelliteLayerSpec() {
  return {
    id: SATELLITE_LAYER,
    type: 'raster',
    source: SATELLITE_SOURCE,
    layout: { visibility: 'visible' },
    paint: { 'raster-opacity': 1 },
  }
}

function cloneLayer(layer) {
  const nextLayer = { ...layer }

  if (layer.layout) {
    nextLayer.layout = { ...layer.layout }
  }

  if (layer.paint) {
    nextLayer.paint = { ...layer.paint }
  }

  return nextLayer
}

function addSatelliteToStyle(style) {
  const nextStyle = {
    ...style,
    sources: {
      ...style.sources,
      [SATELLITE_SOURCE]: satelliteSourceSpec(),
    },
  }

  const layers = style.layers.map(cloneLayer)
  const firstOverlayLayer = layers.find(
    (layer) => layer.type === 'line' || layer.type === 'symbol'
  )
  const insertIndex = firstOverlayLayer
    ? layers.indexOf(firstOverlayLayer)
    : layers.length

  nextStyle.layers = [
    ...layers.slice(0, insertIndex),
    satelliteLayerSpec(),
    ...layers.slice(insertIndex),
  ]

  return nextStyle
}

function hideHybridBaseLayer(layer) {
  if (layer.type === 'background') {
    return {
      ...layer,
      paint: {
        ...layer.paint,
        'background-color': 'rgba(0, 0, 0, 0)',
        'background-opacity': 0,
      },
    }
  }

  if (
    layer.type === 'fill' ||
    layer.type === 'fill-extrusion' ||
    (layer.type === 'raster' && layer.id === 'natural_earth')
  ) {
    return {
      ...layer,
      layout: {
        ...layer.layout,
        visibility: 'none',
      },
    }
  }

  return layer
}

export function buildSatelliteStyle() {
  return {
    version: 8,
    sources: {
      [SATELLITE_SOURCE]: satelliteSourceSpec(),
    },
    layers: [
      {
        id: 'background',
        type: 'background',
        paint: { 'background-color': '#111827' },
      },
      satelliteLayerSpec(),
    ],
  }
}

export function buildReliefStyle() {
  return {
    version: 8,
    sources: {
      opentopo: {
        type: 'raster',
        tiles: OPENTOPO_TILES,
        tileSize: 256,
        attribution:
          '© OpenTopoMap (CC-BY-SA), SRTM | Map data: © OpenStreetMap contributors',
        maxzoom: 17,
      },
    },
    layers: [
      {
        id: 'background',
        type: 'background',
        paint: { 'background-color': '#f8f4f0' },
      },
      {
        id: 'opentopo',
        type: 'raster',
        source: 'opentopo',
      },
    ],
  }
}

export function applySatelliteTransform() {
  return buildSatelliteStyle()
}

export function applyHybridTransform(style) {
  const nextStyle = addSatelliteToStyle(style)
  nextStyle.layers = nextStyle.layers.map(hideHybridBaseLayer)

  return nextStyle
}
